import { Box } from "@mui/material";

import { useEffect, useState } from "react";

import PolicyUpdateForm from "./form";
import { HRService } from "../../../../config";
import { AllPoliciesColumns, LeaveApproversColumns } from "../../../../data/Columns/hrmanagement";
import { LeaveApprovers, allPolicies } from "../../../../data/Queries/HRmanagement/leavemanagement";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import ApproversForm from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import RecurringTypesForm from "./form";

const base_url = HRService.uri;
const actions = {
  entity: "Recurring Types",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  
  dataObject: {
    objectName: "allRecurringTypes",
    parameters: "",
  },
  showStatus: true,
};
function RecurringTypesTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="Recurring Types"
          subtitle="View all Recurring Types , add and edit"
          FormComponent={RecurringTypesForm}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default RecurringTypesTable;
